import BCColorPicker, { OnColorChangeComplete } from '../../../BCColorPicker';
import { findMessage } from '../../../BCIntl';
import { IPropertyComponentProps, IPropertyItem } from '../../entities';

export default function ColorPickerProperty(props: IPropertyComponentProps) {
	const replaceValue = (item: IPropertyItem, newValue: any) => {
		props.onValueChanged(item, newValue);
	};

	const onChange: OnColorChangeComplete = value => {
		const colorRgb = value.toRgbString();
		props.customChangeEvent
			? props.customChangeEvent(colorRgb)
			: replaceValue(props.item, colorRgb);
	};

	return (
		<BCColorPicker
			value={props.value || 'rgba(0, 0, 0, 0)'}
			onChangeComplete={onChange}
			style={props.style}
			disabled={props.item.disabled || props.item.readOnly || props.readonly}
			disabledAlpha={props.item.externalData?.disableAlpha}
			presets={
				props.item.externalData?.presetColors
					? [
							{
								colors: props.item.externalData?.presetColors,
								label: findMessage.get('101451')
							}
					  ]
					: undefined
			}
			size="small"
		/>
	);
}
